exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group--error input,\n.form-group--error textarea,\n.form-group--error select,\n.form-group--error input:focus,\n.form-group--error input:hover {\n  border-color: #f79483;\n}\n.steps-wrapper .step .circle i[data-v-3ee86246] {\n  background-color: #f35a78 !important;\n}\n.custom-dot {\n  width: 16px;\n  height: 16px;\n  border-radius: 100%;\n  background-color: #D8406C;\n  transition: all 0.3s;\n}\n.custom-dot:hover {\n  transform: rotateZ(45deg);\n  cursor: pointer;\n}\n.custom-dot.focus {\n  border-radius: 50%;\n}", ""]);

// exports
